// `icon` is the base name of the icon in the shared S3 bucket, without the
// `.svg`. The page builds the full URL off `s3ImagesBaseURL`.
const FEATURE_TILES = [
  {
    id: "ai-fluency",
    icon: "auto-fix-high",
    title: "AI fluency",
    description: "Talent comes trained in AI, knowing what to trust and where to draw the line",
  },
  {
    id: "immersive-training",
    icon: "dynamic-feed",
    title: "Immersive training",
    description: "Custom built EHR and other apps for hands-on practice & evaluation",
  },
  {
    id: "ai-simulations",
    icon: "contacts",
    title: "AI simulations",
    description: "Talent is coached on their performance in AI calls simulating real world scenarios",
  },
  {
    id: "sound-communication",
    icon: "mic-none",
    title: "Sound communication",
    description: "Assessed by our team, backed by AI scoring across 4 dimensions & 7 tests",
  },
  {
    id: "video-profiles",
    icon: "smart-display",
    title: "Video profiles",
    description: "Get a sense of who you’ll be working with before you request an interview",
  },
  {
    id: "specialized-backgrounds",
    icon: "star",
    title: "Specialized backgrounds",
    description: "Licensed Medical, Dental and Accounting professionals available",
  },
  {
    id: "vetted-by-humans-and-ai",
    icon: "contact-emergency",
    title: "Vetted by humans & AI",
    description: "Practice and qualifying interviews, conducted by AI, confirmed by humans",
  },
  {
    id: "trust-built-in",
    icon: "https",
    title: "Trust, built-in",
    description: "Government and third party background checks before day one",
  },
  {
    id: "expansive-training-library",
    icon: "video-library",
    title: "Expansive training library",
    description: "Course material developed for dozens of industry leading EHRs and software",
  },
  {
    id: "assessments",
    icon: "check-box",
    title: "Assessments",
    description: "Evaluated for personality, working style, comprehension and IT awareness",
  },
  {
    id: "native-context",
    icon: "workspaces",
    title: "Native context",
    description: "Trained in US culture, healthcare, insurance and accounting",
  },
  {
    id: "yours-truly",
    icon: "sensor-occupied",
    title: "Yours, truly",
    description: "Your hire works only for you. No shared staff, no rotating faces",
  },
];

export default FEATURE_TILES;
